/**
 * SimpleGrid Component
 * Auto-layout grid with responsive columns
 */

import React, { forwardRef } from 'react';
import { Grid } from '../primitives/Grid';

/**
 * SimpleGrid Component
 * 
 * @example
 * <SimpleGrid columns={3} spacing={4}>
 *   <Box>1</Box>
 *   <Box>2</Box>
 *   <Box>3</Box>
 * </SimpleGrid>
 * 
 * <SimpleGrid minChildWidth="200px" spacing={4}>
 *   <Box>Auto-sized</Box>
 *   <Box>Auto-sized</Box>
 * </SimpleGrid>
 */
export const SimpleGrid = forwardRef(({
  columns,
  minChildWidth,
  spacing,
  spacingX,
  spacingY,
  ...props
}, ref) => {
  // Calculate template columns
  let templateColumns;
  
  if (minChildWidth) {
    templateColumns = `repeat(auto-fit, minmax(${minChildWidth}, 1fr))`;
  } else if (columns) {
    if (typeof columns === 'object') {
      // Responsive columns object
      // Note: This would need more complex handling for full responsive support
      const defaultColumns = columns.base || columns.sm || 1;
      templateColumns = `repeat(${defaultColumns}, 1fr)`;
    } else {
      templateColumns = `repeat(${columns}, 1fr)`;
    }
  } else {
    templateColumns = 'repeat(1, 1fr)';
  }

  return (
    <Grid
      ref={ref}
      templateColumns={templateColumns}
      gap={spacing}
      columnGap={spacingX || spacing}
      rowGap={spacingY || spacing}
      {...props}
    />
  );
});

SimpleGrid.displayName = 'SimpleGrid';

export default SimpleGrid;
